import React, { useEffect, useState } from 'react';
import { FilterProps } from '../../../common/filter.util';
import { Divider, Grid } from '@mui/material';
import { DeleteIcon } from '../../../../../icons/Delete/DeleteIcon';
import { VentoryColor } from '../../../../../util/color.util';
import MultiSelectionList from '../../../../common/MultiSelectionList/MultiSelectionList';
import SearchBar from '../../../../common/SearchBar/SearchBar';
import { CustomFieldEntityType, CustomFieldUtil } from '../../../../../../types/custom_field';
import { CustomFieldEntityTypeFilter } from '../CustomFieldEntityTypeFilter';

interface CustomFieldEntityTypeFilterDropdownContentProps {
  filter: CustomFieldEntityTypeFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

export function CustomFieldEntityTypeFilterDropdownContent({
  filter,
  filterProps,
  setFilterProps,
}: CustomFieldEntityTypeFilterDropdownContentProps) {
  const [query, setQuery] = useState<string>('');

  const filterCustomFieldEntityType = () => {
    return new Set(
      filter.filteredItems([...Object.values(CustomFieldEntityType)], query, filterProps).map(item => item),
    );
  };

  const [values, setValues] = useState<Set<string>>(filterCustomFieldEntityType());

  const handleChange = (selected: Set<string>) => {
    filterProps.customFieldEntityType = selected;
    if (!filterProps.customFieldEntityType?.size) filterProps.customFieldEntityType = undefined;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.customFieldEntityType = undefined;
    setFilterProps({ ...filterProps });
  };

  useEffect(() => {
    setValues(filterCustomFieldEntityType());
  }, [query]);

  return (
    <Grid container>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-ventory-grey-500 text-[13px] font-[500]'>{filter.toLabel()}</p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setQuery(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          selected={filterProps.customFieldEntityType}
          values={values}
          onChange={handleChange}
          toText={id => CustomFieldUtil.customFieldEntityTypeToString(id as CustomFieldEntityType)}
        />
      </Grid>
    </Grid>
  );
}
